// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactSVG from 'react-svg';
import { BrowserView, CustomView, isTablet } from 'react-device-detect';

import SelectWrapped from '../Select';
import ChevronGaucheFast from '../../assets/images/chevron2_off.svg';
import ChevronGauche from '../../assets/images/chevron_off.svg';
import { Wrapper, svgStyle } from './style';

import {
  makeSearch,
  setCriteria,
  setDocumentsPerPage,
  goToNextPage,
  goToPrevPage,
  goToPage
} from '../../actions/search';

import type { Select as SelectType } from '../../types/Select';
import type { SetCriteria } from '../../types/Criteria';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../CurrentLocale';

type Props = {
  currentPage: number,
  totalDocumentCount: number,
  documentsPerPage: number,
  setDocumentsPerPage: string => void,
  setCriteria: SetCriteria => void,
  makeSearch: () => void,
  goToNextPage: (number, number) => void,
  goToPrevPage: () => void,
  goToPage: (number, number) => void,
  sort: string,
  paddingTop: number,
  onlyPagination: boolean,
  screenWidth: number
};

type State = {
  pageValue: ?number
};

class PaginationResults extends Component<Props, State> {
  state = {
    pageValue: null
  };

  optionsPageSize: any = [];
  optionsPertinence: any = [];

  constructor(props) {
    super(props);

    this.optionsPageSize = [
      { value: '12', label: formatMessage({ id: 'paginationResult.12_page' }) },
      { value: '60', label: formatMessage({ id: 'paginationResult.60_page' }) },
      {
        value: '120',
        label: formatMessage({ id: 'paginationResult.120_page' })
      }
    ];

    this.optionsPertinence = [
      { value: '', label: formatMessage({ id: 'paginationResult.sort' }) },
      {
        value: 'datemisenligne',
        label: formatMessage({ id: 'paginationResult.sort_date_add_asc' })
      },
      {
        value: '-datemisenligne',
        label: formatMessage({ id: 'paginationResult.sort_date_add_desc' })
      },
      {
        value: 'anneedatepubli',
        label: formatMessage({ id: 'paginationResult.sort_date_pub_asc' })
      },
      {
        value: '-anneedatepubli',
        label: formatMessage({ id: 'paginationResult.sort_date_pub_desc' })
      }
    ];
  }

  handleSelectPageSize = (option: SelectType): void => {
    const { setDocumentsPerPage, makeSearch } = this.props;

    setDocumentsPerPage(option.value);

    makeSearch();

    window.scrollTo(0, 0);
  };

  handleSelectSort = (option: SelectType): void => {
    const { setCriteria, makeSearch } = this.props;

    setCriteria({ sort: option.value });

    makeSearch();

    window.scrollTo(0, 0);
  };

  handleKeyPress = e => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      this.goToPage();
    }
  };

  getTotalPages = (): number =>
    Math.ceil(this.props.totalDocumentCount / this.props.documentsPerPage);

  goToNextPage = (): void => {
    const { goToNextPage, currentPage, makeSearch } = this.props;

    goToNextPage(currentPage, this.getTotalPages());

    makeSearch();

    window.scrollTo(0, 0);
  };

  goToPrevPage = (): void => {
    const { goToPrevPage, makeSearch } = this.props;

    goToPrevPage();

    makeSearch();

    window.scrollTo(0, 0);
  };

  goToPage = (): void => {
    const { pageValue } = this.state;
    const { goToPage, makeSearch, currentPage } = this.props;

    if (currentPage !== pageValue && pageValue !== null) {
      goToPage(parseInt(pageValue, 0), this.getTotalPages());

      makeSearch();

      this.setState({ pageValue: null });

      window.scrollTo(0, 0);
    }
  };

  gotoFirstPage = (): void => {
    const { goToPage, makeSearch } = this.props;
    goToPage(1, this.getTotalPages());

    makeSearch();

    this.setState({ pageValue: null });

    window.scrollTo(0, 0);
  };

  goToLastPage = (): void => {
    const { goToPage, makeSearch } = this.props;

    const totalPage = this.getTotalPages();
    goToPage(parseInt(totalPage, 0), totalPage);

    makeSearch();

    this.setState({ pageValue: null });

    window.scrollTo(0, 0);
  };

  handleInput = ({ target: { value } }) => {
    const totalPages = this.getTotalPages();
    const pageValue = value > totalPages ? totalPages : value;

    this.setState({ pageValue });
  };

  render() {
    const { pageValue } = this.state;
    const {
      currentPage,
      totalDocumentCount,
      documentsPerPage,
      sort,
      paddingTop = 0,
      onlyPagination = false
    } = this.props;

    const pageSizeValue = this.optionsPageSize.find(
      l => l.value === documentsPerPage.toString()
    );

    const sortValue = this.optionsPertinence.find(l => l.value === sort);

    const selectViews = (
      <React.Fragment>
        <div className="doc-found">
          {totalDocumentCount}{' '}
          <FormattedMessage id="paginationResults.doc_found" />
        </div>

        <BrowserView>
          <div className="select">
            <SelectWrapped
              options={this.optionsPageSize}
              value={pageSizeValue}
              onChange={this.handleSelectPageSize}
            />
          </div>
        </BrowserView>
        <div className="select2">
          <SelectWrapped
            options={this.optionsPertinence}
            value={sortValue}
            onChange={this.handleSelectSort}
          />
        </div>
      </React.Fragment>
    );

    return (
      <Wrapper style={{ marginTop: paddingTop }}>
        {!onlyPagination && (
          <React.Fragment>
            {!isTablet && selectViews}
            <CustomView condition={isTablet} className="container-left">
              <div>{selectViews}</div>
            </CustomView>
          </React.Fragment>
        )}

        <div
          className="navigation"
          style={{
            margin:
              onlyPagination || this.props.screenWidth <= 1280
                ? '0 auto'
                : 'initial'
          }}
        >
          <a
            className={`${currentPage < 2 ? 'icon--disabled' : ''} change-page`}
            title={formatMessage({ id: 'paginationResult.first_page' })}
            onClick={() => currentPage > 1 && this.gotoFirstPage()}
          >
            <ReactSVG svgStyle={svgStyle} src={ChevronGaucheFast} />
          </a>

          <a
            className={`${currentPage < 2 ? 'icon--disabled' : ''} change-page`}
            onClick={() => currentPage > 1 && this.goToPrevPage()}
            title={formatMessage({ id: 'paginationResult.previous_page' })}
          >
            <ReactSVG svgStyle={svgStyle} src={ChevronGauche} />
          </a>

          <div className="doc-found doc-found-marge">
            <FormattedMessage id="paginationResults.page" />
            <input
              type="number"
              onChange={this.handleInput}
              onBlur={this.goToPage}
              onKeyPress={this.handleKeyPress}
              value={pageValue || currentPage}
              min={1}
              max={parseInt(this.getTotalPages(), 0) || 0}
            />
            <FormattedMessage id="paginationResults.of" />{' '}
            {this.getTotalPages()}
          </div>

          <a
            className={`${
              currentPage >= this.getTotalPages() ? 'icon--disabled' : ''
            } change-page rotate-icon`}
            onClick={() =>
              currentPage < this.getTotalPages() && this.goToNextPage()
            }
            title={formatMessage({ id: 'paginationResult.next_page' })}
          >
            <ReactSVG svgStyle={svgStyle} src={ChevronGauche} />
          </a>

          <a
            className={`${
              currentPage >= this.getTotalPages() ? 'icon--disabled' : ''
            } change-page rotate-icon`}
            title={formatMessage({ id: 'paginationResult.last_page' })}
            onClick={() =>
              currentPage < this.getTotalPages() && this.goToLastPage()
            }
          >
            <ReactSVG svgStyle={svgStyle} src={ChevronGaucheFast} />
          </a>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ results, search }) => ({
  currentPage: results.pagination.currentPage,
  totalDocumentCount: results.pagination.totalDocumentCount,
  documentsPerPage: results.pagination.documentsPerPage,
  sort: search.sort
});

const mapDispatchToProps = dispatch => ({
  setDocumentsPerPage: documentsPerPage =>
    dispatch(setDocumentsPerPage(documentsPerPage)),
  setCriteria: arg => dispatch(setCriteria(arg)),
  goToNextPage: (currentPage, totalPages) =>
    dispatch(goToNextPage(currentPage, totalPages)),
  goToPrevPage: () => dispatch(goToPrevPage()),
  goToPage: (pageNumber, totalPage) =>
    dispatch(goToPage(pageNumber, totalPage)),
  makeSearch: () => dispatch(makeSearch())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaginationResults);



// WEBPACK FOOTER //
// ./src/components/PaginationResults/index.js